import { render } from "./StepbarCompany.vue?vue&type=template&id=dfbc2fc4&scoped=true"
import script from "./StepbarCompany.vue?vue&type=script&lang=js"
export * from "./StepbarCompany.vue?vue&type=script&lang=js"

import "./StepbarCompany.vue?vue&type=style&index=0&id=dfbc2fc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfbc2fc4"]])

export default __exports__